import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { EssentialService } from './essential.service';
import { HttpClient } from '@angular/common/http'
import { objectEach } from 'highcharts';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  getSlugData: any = JSON.stringify(localStorage.getItem('slugData'));
  siteMapDataSubject = new BehaviorSubject<any>(null);
  siteMap$: Observable<any> = this.siteMapDataSubject.asObservable();
  cache={};
  oneTime=false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private essentialsService: EssentialService,
    private http: HttpClient
  ) {
  }
  NoMenuSelect=true;
  fisrtTime=true
  menuData = {};
   queryCodeSubject= new BehaviorSubject<any>(null);
   queryCode$:Observable<any>= this.queryCodeSubject.asObservable()
   codeValue;
  getMenu(id, data, slug="") {

    const menuIndex = Object.keys(this.menuData).indexOf(id.toString());
    const cacheMenuIndex = Object.keys(this.cache).indexOf(id.toString());
    if (menuIndex === -1) {
      this.essentialsService.getMenusByGroup(id,slug)
        .subscribe((res: any) => {
          Object.assign(this.menuData, {
            [id]: {
              activeLinkId: 0,
              activeLinkParents: [],
              activelinkRootLink: [],
              flatMenu: []
            }
          });

          Object.assign(this.cache,{
            [id.toString()]: [...res]
          });
          let modifiedResponse = this.updateActiveSlug(res,slug);
          this.buildMenu(id, modifiedResponse, slug)
        });
    }else {
      let modifiedResponse = this.updateActiveSlug(this.cache[id.toString()],slug);

      this.buildMenu(id, modifiedResponse, slug)
    }
  }

  private updateActiveSlug(res,slug){
    if(!res ||res.length==0 ){
    
      return [];
      
    }else if(res){
      return res.map((item)=>{
        return {...item ,
                isActive :this.checkIsActive(item,slug),
                childs:this.updateActiveSlug(item.childs,slug) 
                }})
    }
    return res;
  }
 
  private checkIsActive(menuItem,slug=""){
    // this.queryCode$.subscribe(res=>{
    //   this.codeValue=res;
    //  })
if(window.location.search){
  return true
}
    if(menuItem.slug.toLowerCase().split('?')[0]  == slug.toLowerCase() || menuItem.childs.findIndex(child=>child.slug.toLowerCase()  == slug.toLowerCase() ) >-1){
     
    if(!this.NoMenuSelect){
      return true;
    }
    if(!this.fisrtTime){
     
      return true
    }
      let params:any={};
      menuItem.params.forEach(element => {
        if(element.key=="code" && localStorage.getItem("codeValue") ){
          Object.assign(params,{[element.key]:localStorage.getItem("codeValue")});
        }else{ Object.assign(params,{[element.key]:element.value});}
       

      });
 
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams:params,
        queryParamsHandling: 'merge',
        // preserve the existing query params in the route
       // skipLocationChange: true
        // do not trigger navigation
      });
      localStorage.removeItem("codeValue")
      this.fisrtTime=false;
      return true;
    }else{
      return false;

    }
  }

  public getSiteMap(groupId) {
    return this.http.get(`/Menus/GetMenusByGroupId/${groupId}`).pipe(
      tap(res => {
        this.siteMapDataSubject.next(res);
      })
    )
  }


  public GetMenusByGroupId(groupId:number,activeSlug:string) {
    if(activeSlug){
      return this.http.get(`/Menus/GetMenusByGroupId/${groupId}/${activeSlug}`).pipe(
        tap(res => {
          this.siteMapDataSubject.next(res);
        })
      )
    };

   return this.http.get(`/Menus/GetMenusByGroupId/${groupId}`).pipe(
    tap(res => {
      this.siteMapDataSubject.next(res);
    })
  )}

  getParentMenus(id, slug) {
    const menuIndex = Object.keys(this.menuData).indexOf(id.toString());
    if (menuIndex === -1) {
      this.essentialsService.getParentMenus(id)
        .subscribe((res: any) => {
          Object.assign(this.menuData, {
            [id]: {
              activeLinkId: 0,
              activeLinkParents: [],
              activelinkRootLink: [],
              flatMenu: []
            }
          });
          this.buildMenu(id, res, slug)
        });
    }

  }
  getRelatedSlugs(slug) {
    return this.http.get(`/RelatedSlug/GetRelatedSlugsInfo/${slug}`)
  }

  resetMenu() {
    let categories = Object.keys(this.menuData);
    this.menuData = {};
    categories.forEach(element => {
      this.getMenu(element, null, '');
    });
  }

  buildMenu(id, menu, slug) {
    this.menuData[id].flatMenu = [];
    this.flattenMenu(id, menu);
    this.menuData[id].flatMenu = this.menuData[id].flatMenu.sort(sortByOrder);
    this.setActiveLink(id, slug);
  }


  flattenMenu(id, menu) {
    const m = [...menu];

    for (const item of m) {
      const { childs } = item;
      this.menuData[id].flatMenu.push(item);
      if (childs && childs.length > 0) { this.flattenMenu(id, childs); }
    }
  }

  setActiveLink(id, slug) {
    if (id) {

      if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
      // const total = this.menuData[id].flatMenu
      //   .filter(item => (item.menuType === 2 || item.menuType === 6) && item.slug === slug);

      const total = [];
      for (let index = 0; index < this.menuData[id].flatMenu.length; index++) {
        const element = this.menuData[id].flatMenu[index];
        if (typeof element !== 'string') {
          if ((element.menuType === 2 || element.menuType === 6 || element.menuType === 4 ||element.menuType === 7) && element.slug.includes(slug)) {
            total.push(element);
          }
        }

      }
      // for (let menuItem of  this.menuData[id].flatMenu){
      //   if(typeof menuItem !== 'string'){
      //     if((menuItem.menuType === 2 || menuItem.menuType === 6) && menuItem.slug === slug){
      //       total.push(menuItem);
      //     }
      //   }
      // }

      if (total.length === 0) { return; }

      this.menuData[id].activeLinkParents = [];
      this.menuData[id].activelinkRootLink = [];

      // if (total.length > 1) {
      this.menuData[id].activeLinkId = total[0].id;
      this.menuData[id].activeLinkParents.push(total[0].id);
      this.setLinkParents(id, this.menuData[id].activeLinkId);
      // }
    }

  }

  setLinkParents(id, activeLinkId: number) {
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
    const targetLink = this.menuData[id].flatMenu.find(link => link.id === activeLinkId);
    if (!targetLink) { return; }

    if (targetLink.parentId) {
      this.menuData[id].activeLinkParents.push(targetLink.parentId);
      this.setLinkParents(id, targetLink.parentId);
    }
    else {
      this.menuData[id].activelinkRootLink.push(targetLink)
    }
  }

  getActiveLink(id) {
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1 || !this.menuData[id].activeLinkId) { return; }
    return this.menuData[id].flatMenu.filter(x => x.id === this.menuData[id].activeLinkId);
  }

  getParentLink(id, parentId) {
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
    return this.menuData[id].flatMenu.filter(x => x.id === parentId);
  }

  getActiveLinkChildren(id: number, parentId) {
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
    return this.menuData[id].flatMenu.filter(x => x.parentId === parentId);
  }

  getActiveLinkSiblings(id: number) {
    if (!id || this.menuData[id].flatMenu.length == 0) { return []; }
    const activeLink = this.menuData[id].flatMenu.find(x => x.id === this.menuData[id].activeLinkId);
    return this.menuData[id].flatMenu.filter(x => x.parentId === activeLink.parentId);
  }

  isActiveChild(id, linkId: number) {
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
    const activeChild = this.menuData[id].flatMenu.find(item =>
      (item.menuType === 2 || item.menuType === 6 || item.menuType === 7 || item.menuType === 4) && item.slug === this.getSlugData.slug && item.id === linkId && item.parentId !== null);

    if (!activeChild) { return; }
    return activeChild.id === linkId;
  }

  isHaveChildren(id, linkId: number) {
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
    return this.menuData[id].flatMenu.filter(link => link.parentId === linkId).length > 0;
  }

  navigateToSection(el) {
    this.NoMenuSelect = false;
    var elmnt = document.getElementById(el);
    elmnt.scrollIntoView();
  }

  getRootMenu(id) {
    if (id) {
      if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
      return this.menuData[id].flatMenu.filter(i => !i.parentId);
    }

  }
  public navigateTo(slug, el?, menuGroupId?) {
    this.NoMenuSelect = false;
    
    if (!el && !menuGroupId) {
      if(slug.includes('?')){
        this.router.navigateByUrl(slug)
        window.scrollTo(0, 0)
      }else{this.router.navigate([slug]);
        window.scrollTo(0, 0)}
      
    }
    else if (!el && menuGroupId) {
      let currentRoute = window.location.pathname;
      let queryString = window.location.search;
      if (currentRoute.includes(slug) && !queryString.includes('mnuId=' + menuGroupId)) {
       
          
            if(slug.includes('?')){
              this.router.navigateByUrl(`${slug}&mnuId=${menuGroupId}`)
              window.scrollTo(0, 0)
            }else{this.router.navigate([slug], { queryParams: { mnuId: menuGroupId } })
            window.scrollTo(0, 0)
          }
            
          
      } else {

         if(slug.includes('?')){
              this.router.navigateByUrl(`${slug}&mnuId=${menuGroupId}`)
              window.scrollTo(0, 0)
            }else{this.router.navigate([slug], { queryParams: { mnuId: menuGroupId } })
            window.scrollTo(0, 0)}
      }
    }
    else if (el && slug) {
      if (menuGroupId) {
        this.router.navigate([slug], { fragment: el, queryParams: { mnuId: menuGroupId } });

      } else {
        this.router.navigate([slug], { fragment: el });
      }
      setTimeout(() => {
        const elmnt = document.getElementById(el);
        if (elmnt && elmnt != null) {
          elmnt.scrollIntoView();
        }
      }, 500);
    }

  }

  isMenuReady(id) { return Object.keys(this.menuData).indexOf(id.toString()) >= 0; }

}



function sortByOrder(a: any, b: any) {
  return a['order'] - b['order']
}
